import $ from "jquery";

$(function () {
  $('.moreinfo-button').on("click", function () {
    $(this).toggleClass("is-active");
    $(this).parent().parent().toggleClass("is-active");
  });
});
